module.exports = __webpack_public_path__ + "img/thermocouple-middle-J.a1e7b56c.png";